import { useContext } from "react";

import { UserContext } from "../../../shared/auth/user-context";
import {
  NETWORK_BUYER_V2_ACCESS_PERMISSION,
  NETWORK_SUPPLIER_V2_ACCESS_PERMISSION,
} from "../../../shared/auth/user-utils";

export type NetworkCapabilities = {
  isBuyer: boolean;
  isSupplier: boolean;
};

/**
 * The `network-*-v2` access permissions are checked here, and only here, so call sites (route
 * guards, the merged landing) never check permissions directly.
 *
 * Checked via `hasPermission` (Frontegg entitlements) on purpose: the network backend guards
 * (`@HasAnyPermission`) resolve the same entitlements server-side, so entitlements — not the raw
 * JWT permissions claim — decide whether an API call would succeed. A tenant whose token carries
 * the permission but whose entitlements deny it (e.g. no plan configured) would be rejected by the
 * backend too (CFC-2591).
 */
export function useNetworkCapabilities(): NetworkCapabilities {
  const { hasPermission } = useContext(UserContext);

  return {
    isBuyer: hasPermission(NETWORK_BUYER_V2_ACCESS_PERMISSION),
    isSupplier: hasPermission(NETWORK_SUPPLIER_V2_ACCESS_PERMISSION),
  };
}
